import { ChangeUserGroupsComponentProps, ChangeUserGroupsField } from 'app/area/favourite-administration/list/change-user-groups/types';
import { ChangeOptionType } from 'app/area/favourite-administration/list/types';

export const hasFieldValueChanged = (prevProps: ChangeUserGroupsComponentProps, props: ChangeUserGroupsComponentProps) => {
  const previousForm = prevProps?.list?.changeUserGroups?.form ?? {};
  const currentForm = props?.list?.changeUserGroups?.form ?? {};

  return Object.keys(ChangeUserGroupsField)
    .some(field => currentForm[field] !== previousForm[field]);
};

export const emptyUserGroups = (props: ChangeUserGroupsComponentProps) => {
  const changeUserGroups = props?.list?.changeUserGroups?.form ?? {};

  return props.list.changeUserGroups.state === ChangeOptionType.Add
    && (changeUserGroups[ChangeUserGroupsField.replaceExistingUserGroups] || []).length === 0;
};

export const isDisabled = (props: ChangeUserGroupsComponentProps) => {
  const changeUserGroupsFields = Object.keys(ChangeUserGroupsField);
  const changeUserGroups = props?.list?.changeUserGroups;
  const fieldsError = changeUserGroups?.validation
    && changeUserGroupsFields.map(item => changeUserGroups?.form[item] && changeUserGroups?.validation[item]).filter(f => !!f);

  return fieldsError?.length > 0 && !changeUserGroups?.isDirty;
};
